export const DEVICE_CONNECTION_NOTIFY = 'DEVICE_CONNECTION_NOTIFY'
export const LINK_DEVICE_RESPONSE = 'LINK_DEVICE_RESPONSE'
export const SCREENSHOT_DEVICE_RESPONSE = 'SCREENSHOT_DEVICE_RESPONSE'